import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  is_page_load: false,
  status: false,
  content: null,
  landing_page_id : null,
};

const landingpageSlice = createSlice({
  name: "landingpage",
  initialState,
  reducers: {
    setPageLoad(state, action) {
      state.is_page_load = action.payload.is_page_load;
    },
    setPagecontent(state, action) {
      state.status = action.payload.status;
      state.content = action.payload.content;
    },
    setPageId(state,action) {
      state.landing_page_id = action.payload.id
    }
  },
});

export const landingPageAction = landingpageSlice.actions;
export default landingpageSlice.reducer;
